import { ECE } from '@BUP/constants'
import { useContext } from 'react'
import { RoleContext } from '@BUP/contexts/RoleContext'
import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetDiagnosisSurveys = (termId, options = {}) => {
  const role = useContext(RoleContext)
  const isRoleECE = role?.type === ECE

  const query = useApiQuery(
    ['diagnosis-surveys', termId],
    'schools',
    `/terms/${termId}/diagnostic-surveys`,
    {
      enabled: Boolean(termId && isRoleECE),
      ...options
    },
    { authenticated: true, version: 3 }
  )

  return {
    diagnosisSurveys: isRoleECE ? (query.data ?? []) : [],
    isLoadingDiagnosisSurveys: query.isLoading,
    isFetchingDiagnosisSurveys: query.isFetching,
    errorDiagnosisSurveys: query.isError ? query.error : null,
    getDiagnosisSurveys: query.refetch
  }
}
